function formatLedgerBalance (pgRows) {
  const result = {}
  for (const row of pgRows) {
    const sku = row.sku
    const key = `product:${sku}`
    const batches = {}
    if (Array.isArray(row.batches)) {
      for (const batch of row.batches) {
        if (!batch) continue
        const { batch: batchId, amount } = batch
        if (!batchId || amount == null) continue
        if (/batchNo:unknown/i.test(batchId)) continue
        const normalizedBatchId = batchId.replace(/^product:[^:]+/, key)
        batches[normalizedBatchId] = amount
      }
    }
    result[key] = {
      total: row.amount,
      availableTotal: row.amount,
      'field:partner-balance': row.partner_balance || 0,
      batches
    }
  }
  return result
}

module.exports = { formatLedgerBalance }
